import { Injectable } from '@angular/core';
import { HttpClientModule ,HttpRequest} from '@angular/common/http';
import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {httpOptionsImage} from '../../configurations/configuration';


export interface StreamDef { name: string; url: string; }
export interface AssetData {
  id: string;
  videoUrl: string;
  video_H_Url: string;
  video_dual_Url: string;
  video_quad_Url: string;
  audiourl: string;
  programcutUrl: string;
  Program: string;
  streamUrls: StreamDef[];
  contentType?: 'vod' | 'live';
  signalChannel?: string;
  chatEnabled?: boolean;
  chatChannel?: string;
  multiViewEnabled?: boolean;
}

export interface CellConfig {
  camIndex: number;
  width: string;
  height: string;
  x: string;
  y: string;
}

export interface LayoutConfig { layout: CellConfig[][]; }
export interface LayoutConfigsMap {
  grid9: LayoutConfig;
  grid4: LayoutConfig;
  grid2: LayoutConfig;
  gridH: LayoutConfig;
}

@Injectable({
  providedIn: 'root',
  
})
export class AssetService {

    private ASSET_KEY = 'assetData';
    private LAYOUT_KEY = 'layoutConfigs';
    API_ENDPOINT = '/asset/createstreamconfig';

  constructor(private http: HttpClient) { }

    updateAsset(postObj:any) : Observable<any> {

        console.log(">>updateAssetUrl>>",environment.updateAssetUrl);
        postObj.langId = localStorage.getItem('languageId');
        if(postObj.langId== null){
            postObj.langId = '1';

        }

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateAssetUrl, postObj,httpOptions);
    }

    insertAsset(postObj:any) : Observable<any> {

        postObj.langId = localStorage.getItem('languageId');

        if(postObj.langId== null){
            postObj.langId = '1';

        }
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertAssetUrl, postObj,httpOptions);
    }

    getAsset( id: any, langId:any) : Observable<any> {

        langId = localStorage.getItem('languageId');

        if(langId == null){
            langId = '1';
        }

        if(id){
            return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getAssetUrl+"/" + id +"/" + langId);
        }

    }


    getRefreshUplynk( ) : Observable<any> {

            return this.http.get(environment.apiURL + environment.adminApiUrl + environment.refreshUplynkUrl)
    }

    getAllAsset(filterObj,start,limit){

        filterObj.languageId = localStorage.getItem('languageId');
        if(filterObj.languageId == null){
            filterObj.languageId = '1';
        }


        let urlGetAllAsset = environment.apiURL + environment.adminApiUrl + environment.getAssetUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllAsset)
    }

    /*getGlobalAsset(filterObj,start,limit){
        let urlGetAllAsset = environment.apiURL + environment.adminApiUrl + environment.getGlobalAssetUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllAsset)
    }*/

    deleteAsset(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteAssetUrl, postObj,httpOptions);
    }
    deleteMultiple(postObj:any) : Observable<any> {
      return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteMultiple, postObj,httpOptions);
  }

    insertAssetGroup(postObj) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertAssetGroupUrl, postObj,httpOptions);
    }

    updateAssetGroup(postObj:any) : Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateAssetGroupUrl, postObj,httpOptions);
    }

    getAssetGroup( id: any, langId:any) : Observable<any> {

        langId = localStorage.getItem('languageId');


        if(id){
            return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getAssetGroupUrl+"/" + id +"/" + langId);
        }

    }

    getAssetData(id): AssetData {
        const raw = localStorage.getItem(this.ASSET_KEY);
        if (raw) return JSON.parse(raw);
        // defaults
        return {
          id: id,
          videoUrl: '',
          video_H_Url: '',
          video_dual_Url: '',
          video_quad_Url: '',
          audiourl: '',
          programcutUrl: '',
          Program: '',
          streamUrls: Array.from({ length: 9 }, (_, i) => ({ name: `Camera ${i + 1}`, url: '' }))
        };
      }
    
      setAssetData(data: AssetData) {
        localStorage.setItem(this.ASSET_KEY, JSON.stringify(data));
      }
    
      getLayouts(): LayoutConfigsMap {
        const raw = localStorage.getItem(this.LAYOUT_KEY);
        if (raw) return JSON.parse(raw);
        return {
          grid9: { layout: [] },
          grid4: { layout: [] },
          grid2: { layout: [] },
          gridH: { layout: [] }
        };
      }

      getdefaultLayouts():LayoutConfigsMap {
        const raw = localStorage.getItem(this.LAYOUT_KEY);
        if (raw) return JSON.parse(raw);
        return {
          grid9: { 
            "layout": [
                [
                    {
                        "camIndex": 0,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "0%",
                        "y": "0%"
                    },
                    {
                        "camIndex": 1,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "0%",
                        "y": "33.33%"
                    },
                    {
                        "camIndex": 2,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "0%",
                        "y": "66.66%"
                    }
                ],
                [
                    {
                        "camIndex": 3,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "33.33%",
                        "y": "0%"
                    },
                    {
                        "camIndex": 4,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "33.33%",
                        "y": "33.33%"
                    },
                    {
                        "camIndex": 5,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "33.33%",
                        "y": "66.66%"
                    }
                ],
                [
                    {
                        "camIndex": 6,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "66.66%",
                        "y": "0%"
                    },
                    {
                        "camIndex": 7,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "66.66%",
                        "y": "33.33%"
                    },
                    {
                        "camIndex": 8,
                        "width": "33.33%",
                        "height": "33.33%",
                        "x": "66.66%",
                        "y": "66.66%"
                    }
                ]
            ]
        },
          grid4: {    
              "layout": [
            [
                {
                    "camIndex": 0,
                    "width": "50%",
                    "height": "50%",
                    "x": "0%",
                    "y": "0%"
                },
                {
                    "camIndex": 3,
                    "width": "50%",
                    "height": "50%",
                    "x": "0%",
                    "y": "50%"
                }
            ],
            [
                {
                    "camIndex": 2,
                    "width": "50%",
                    "height": "50%",
                    "x": "50%",
                    "y": "0%"
                },
                {
                    "camIndex": 4,
                    "width": "50%",
                    "height": "50%",
                    "x": "50%",
                    "y": "50%"
                }
            ],
        ]
    },
          grid2: {
            "layout": [
                [
                    {
                        "camIndex": 0,
                        "width": "50%",
                        "height": "53.1%",
                        "x": "0%",
                        "y": "23%"
                    }
                ],
                [
                    {
                        "camIndex": 3,
                        "width": "50%",
                        "height": "53.1%",
                        "x": "50%",
                        "y": "23%"
                    }
                ],
            ]
        },
          gridH: { 
            "layout": [
                [
                    {
                        "camIndex": 1,
                        "width": "25%",
                        "height": "25%",
                        "x": "0%",
                        "y": "0%"
                    },
                    {
                        "camIndex": 7,
                        "width": "25%",
                        "height": "25%",
                        "x": "0%",
                        "y": "25%"
                    },
                    {
                        "camIndex": 5,
                        "width": "25%",
                        "height": "25%",
                        "x": "0%",
                        "y": "50%"
                    },
                    {
                        "camIndex": 2,
                        "width": "25%",
                        "height": "25%",
                        "x": "0%",
                        "y": "75%"
                    }
                ],
                [
                    {
                        "camIndex": 2,
                        "width": "50%",
                        "height": "50%",
                        "x": "25%",
                        "y": "25%"
                    }
                ],
                [
                    {
                        "camIndex": 8,
                        "width": "25%",
                        "height": "25%",
                        "x": "75%",
                        "y": "0%"
                    },
                    {
                        "camIndex": 3,
                        "width": "25%",
                        "height": "25%",
                        "x": "75%",
                        "y": "25%"
                    },
                    {
                        "camIndex": 9,
                        "width": "25%",
                        "height": "25%",
                        "x": "75%",
                        "y": "50%"
                    },
                    {
                        "camIndex": 6,
                        "width": "25%",
                        "height": "25%",
                        "x": "75%",
                        "y": "75%"
                    }
                ]
            ]
        } 
        };
      }
    


 

      setLayouts(cfg: LayoutConfigsMap) {
        localStorage.setItem(this.LAYOUT_KEY, JSON.stringify(cfg));
      }
    
      sendConfig(config: any): Observable<any> {
        return this.http.post(environment.apiURL + environment.adminApiUrl + this.API_ENDPOINT, config);
      }

      getConfig(id: any): Observable<any> {
        console.log(environment.apiURL + environment.adminApiUrl + "/asset/streamconfig/"+id)
        return this.http.get(environment.apiURL + environment.adminApiUrl + "/asset/streamconfig/"+id);
      }


      generateBackendJSON(layoutConfigs: LayoutConfigsMap,id): any {
        const assetData = this.getAssetData(id);
    
        // ensure 9 stream entries
        const finalStreams: StreamDef[] = [];
        const src = assetData.streamUrls || [];
        for (let i = 0; i < 9; i++) {
          if (src[i]) finalStreams.push(src[i]);
          else finalStreams.push({ url: 'https://example.com/camera' + (i + 1) + '.m3u8', name: 'Camera ' + (i + 1) });
        }
    
        return {
          videoUrl: assetData.videoUrl || '',
          video_H_Url: assetData.video_H_Url || '',
          video_dual_Url: assetData.video_dual_Url || '',
          video_quad_Url: assetData.video_quad_Url || '',
          audiourl: assetData.audiourl || '',
          programcutUrl: assetData.programcutUrl || '',
          streamUrls: finalStreams,
          layoutConfigs: layoutConfigs,
          Program: assetData.Program,
          contentType: assetData.contentType || 'vod',
          signalChannel: assetData.signalChannel || 'volta-control',
          chatEnabled: !!assetData.chatEnabled,
          chatChannel: assetData.chatChannel || ''
        };
      }
    
      defaultAssetData(id): AssetData {
        const streams: StreamDef[] = [];
        for (let i = 0; i < 9; i++) streams.push({ name: 'Camera ' + (i + 1), url: '' });
        return {
          id: id,
          videoUrl: '',
          video_H_Url: '',
          video_dual_Url: '',
          video_quad_Url: '',
          audiourl: '',
          programcutUrl: '',
          Program: '',
          streamUrls: streams,
          contentType: 'vod',
          signalChannel: '',
          chatEnabled: false,
          chatChannel: '',
          multiViewEnabled:true
        };
      }

      emptyLayouts(): LayoutConfigsMap {
        return {
          grid9: { layout: [] },
          grid4: { layout: [] },
          grid2: { layout: [] },
          gridH: { layout: [] }
        };
      }

      clearLayoutAndAsset(): void {
        localStorage.removeItem(this.LAYOUT_KEY);
        localStorage.removeItem(this.ASSET_KEY);
      }
    
      // optional: individual removers
      clearLayout(): void {
        localStorage.removeItem(this.LAYOUT_KEY);
      }
    
      clearAsset(): void {
        localStorage.removeItem(this.ASSET_KEY);
      }

    uploadEpg(file) : Observable<any> {
        return this.http.get(environment.apiURL  + 'epg/import',file);
    }

    uploadEpgfile(url: any,file: any,type) : Observable<any> {
      //  this.http = new HttpClient(this.handler); // to reset the header
        const headers = new HttpHeaders({ 'Content-Type': type });
        const req = new HttpRequest('PUT', url, file)
        console.log(req)
        return this.http.request(req)
    
    }

    uploadEpgdata() : Observable<any> {
        return this.http.get(environment.apiURL  + 'epg/importdata');
    }

}
